import axios from 'axios';

class MenuService{

  static async getUserMenus(userId) {
    try { 
      const result = await axios.get(`/menu/all-menus/${userId}`);
      return result.data ;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  static async getAllMenus() {
    try { 
      const result = await axios.get('/menu/all-menus');
      return result.data ;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export default MenuService;